// extracted by mini-css-extract-plugin
module.exports = {"newsContainer":"style-module--newsContainer--AHmQS","socialMediaSectionHeader":"style-module--socialMediaSectionHeader--3Xhii"};